export enum OnRejectUpSellEnum {
  NAO_FAZER_NADA = 1,
  REDIRECIONAR,
}
